import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import config from './Config.json'
import ConfigEditor from './ConfigEditor'
import Grid from '@material-ui/core/Grid'

class App extends Component {
  render () {
    return (
      <Grid
        alignItems='center'
        justify='center'
        container spacing={16}
      >
        <Grid item xs={11} md={10}>
          <br />
          <Typography variant='h3'>Config Editor</Typography>
          <br />
          <ConfigEditor
            config={config}
            onSave={(config) => console.log('Saving Config...', config)}
          />
        </Grid>
      </Grid>
    )
  }
}

export default App
